export default {
  LOAD_LIST_EVENT_FIELDS(state, data) {
    state.listaEventFields = data;
  },
  PREPARE_TO_EDIT_EVENT_FIELD(state, data) {
    state.eventField = data;
  },
  RESET_EVENT_FIELD(state) {
    state.eventField = {
      evento: { id: null },
      campo: { id: null },
      valor: "",
    };
  },
};
